<template>
  <div class="content container">
    <div class="row">
      <!-- <div class="col-sm-2">
        <img v-if="app.iConData" class="app_logo" :src="app.iConData" />
        <img class="app_logo" :src="app.iConUrl" />
      </div> -->
      <div class="base_info col-sm-2">
        <router-link :to="{name:'AppEdit'}">
          <p class="iconfont icon-jibenxinxi icon"></p>
          <p class="text">基本信息</p>
        </router-link>
      </div>
      <div class="base_info col-sm-2">
        <router-link :to="{name:'AppPreviewResource',params:{app:app}}">
          <p class="iconfont icon-yulanyonghu icon"></p>
          <p class="text">预览资源</p>
        </router-link>
      </div>
      <div class="base_info col-sm-2">
        <router-link :to="{name:'AppMerge',params:{app:app}}">

          <p class="iconfont icon-hebing icon"></p>
          <p class="text">应用合并</p>
        </router-link>
      </div>
      <div v-if="app.useSuperSign&&app.usePrivateAppledeveloperAccount" class="base_info col-sm-2">
        <router-link :to="{name:'AppAppleDeveloperAccount',params:{app:app}}">
          <p class="iconfont icon-kaifazhe icon"></p>
          <p class="text">绑定开发者账号</p>
        </router-link>
      </div>
      <div v-if="app.useSuperSign&&app.useDownloadCode" class="base_info col-sm-2">
        <router-link :to="{name:'AppDownloadCode',params:{shortLink:app.shortLink}}">
          <p class="iconfont icon-gongnengdingyi icon"></p>
          <p class="text">下载码</p>
        </router-link>
      </div>
      <div class="base_info update_and_preview col-sm-1">
        <button @click="update_version" class="btn btn-outline-primary" style="text-align: center;">更新</button>
        <input id="file" @change="file_change" type="file" style="display: none;" />
        <br />
        <button @click="preview(app.shortLink)" class="btn btn-outline-primary" style="text-align: center;">预览</button>
      </div>
    </div>
    <uploadWindow v-if="show_upload_modal" :useSuperSign="app.useSuperSign" :pkgInfo="pkgInfo" :pkgFile="pkgFile" v-on:showModal="showModal">
    </uploadWindow>
    <router-view v-on:setApp="setApp" />
  </div>
</template>

<script>
var self;
import uploadWindow from "./UploadWindow.vue";
export default {
  name: "HelloWorld",
  components: {
    uploadWindow
  },
  mounted() {
    self = this;
  },
  data() {
    return {
      app: {},
      show_upload_modal: false,
      pkgInfo: {},
      pkgFile: null
    };
  },
  methods: {
    setApp: function(app) {
      this.app = app;
    },
    preview: function(link) {
      window.open(this._Global.SHORT_LINK_PREFIX + "/" + link);
    },
    update_version: function() {
      $("#file").click();
    },
    file_change: function(event) {
      console.log("读取文件");
      var file = event.target.files[0];
      var fileType = file.name.substr(file.name.length - 3, file.name.length);
      if (this.app.osName == "iOS" && fileType != "ipa") {
        this.errToastr("上传安装包类型与当前应用不符");
        return;
      }
      if (this.app.osName == "Android" && fileType != "apk") {
        this.errToastr("上传安装包类型与当前应用不符");
        return;
      }
      this.readPkgInfo(file, function(pkgInfo) {
        self.show_upload_modal = true;
        self.pkgInfo = pkgInfo;
        self.pkgFile = event.target.files[0];
      });
    },
    showModal: function(show_upload_modal) {
      this.show_upload_modal = show_upload_modal;
    }
  }
};
</script>

<style scoped>
.app_logo {
  border-radius: 1em;
  margin-top: 1.8em;
  width: 6em;
}

.base_info {
  margin-top: 2em;
  cursor: pointer;
}

.icon {
  font-size: 46px;
  width: 56px;
  height: 56px;
  line-height: 56px;
  color: #9b9b9b;
  margin: 0 auto;
}
.icon-hebing {
  font-size: 40px;
}
.base_info .text {
  margin-bottom: 0;
  margin-top: 10px;
}

.update_and_preview button {
  text-align: right;
  border-radius: 5em;
  width: 5.5em;
  height: 2.5em;
  margin-bottom: 0.5em;
}
a {
  color: #9b9b9b;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/AppInfo.vue